// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".welcome-txt[data-v-5ac13be2] {\n  color: #a3bac0;\n  text-align: center;\n  font-size: 30px;\n}", ""]);
// Exports
module.exports = exports;
